export const ISSUE_REASONS = [
  { value: 'delayed', label: 'Delayed' },
  { value: 'completed-not-received', label: 'Completed, not received' },
  { value: 'damaged', label: 'Damaged' },
  { value: 'lost', label: 'Lost' },
  { value: 'incorrect-return-to-sender', label: 'Incorrect Return to sender' },
  { value: 'incorrect-delivery', label: 'Incorrect Delivery' },
  { value: 'other', label: 'Other' },
] as const;

export type IssueReason = (typeof ISSUE_REASONS)[number]['value'];

export const formatIssueReason = (reason: string): string => {
  return reason
    ?.split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};
